import { render, staticRenderFns } from "./ImportDetailPopup.vue?vue&type=template&id=a5180e88&scoped=true&"
import script from "./ImportDetailPopup.vue?vue&type=script&lang=js&"
export * from "./ImportDetailPopup.vue?vue&type=script&lang=js&"
import style0 from "./ImportDetailPopup.vue?vue&type=style&index=0&id=a5180e88&prod&lang=scss&scoped=true&"
import style1 from "./ImportDetailPopup.vue?vue&type=style&index=1&id=a5180e88&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5180e88",
  null
  
)

export default component.exports